import React from 'react';
import ArrowUp from 'mdi-material-ui/ArrowUp';
import CommentQuestionOutline from 'mdi-material-ui/CommentQuestionOutline';
import classNames from 'clsx';

import { useStyles } from './TravelQuestionsAndAnswers.styles';
import { ButtonLabelEnum } from 'app/shared/enums';
import { Image } from 'app/components/Image';
import { NewButton } from 'app/components/NewButton';
import { scrollSmoothly } from 'app/services/scroll.service';
import { PageContentWrapper } from '../PageContentWrapper';

function TravelQuestionsAndAnswers() {
  const classes = useStyles();

  const HeaderWithIcon = ({ children }: { children: string }) => {
    return (
      <h2
        className={classNames(
          classes.sectionHeader,
          classes.sectionHeaderWithIcon
        )}
      >
        <CommentQuestionOutline />
        {children}
      </h2>
    );
  };

  return (
    <PageContentWrapper
      className={classes.root}
      mainContent={
        <div className={classes.qa}>
          <div className={classNames(classes.section, classes.sectionWarranty)}>
            <div className={classes.sectionWrapper}>
              <div className={classes.warrantyInfo}>
                Gwarancja bezpiecznego zakupu polisy
              </div>
              <Image
                src="./images/logos/ssl.png"
                srcSetWebp={'./images/logos/ssl.webp'}
                alt="ssl"
                className={classes.warrantyImage}
              />
            </div>
          </div>
          <div
            className={classes.fullWidth}
            id={'travelQuestionsAndAnswersSection'}
          >
            <div className={classNames(classes.section, classes.sectionGrey)}>
              <div className={classes.sectionWrapper}>
                <h3 className={classes.sectionHeader}>
                  Kalkulator ubezpieczeń turystycznych
                </h3>
                <p className={classes.paragraph}>
                  Dołącz do tysięcy oszczędnych i&nbsp;sprytnych podróżników,
                  którzy ubezpieczyli się na wyjazd za granicę dzięki darmowemu
                  kalkulatorowi ubezpieczeń online! To bezpłatna porównywarka,
                  która wyszukuje konkurencyjne ubezpieczenia turystyczne,
                  sportowe (zarówno narciarskie, jak i&nbsp;dla miłośników
                  sportów wodnych) oraz na wyjazd do pracy.
                  <br />
                  <br />
                  Wystarczy, że uzupełnisz miniankietę, aby porównywarka
                  zaoferowała Ci korzystne pakiety. Dzięki wyróżnieniu
                  najważniejszych danych w&nbsp;tabeli możesz raz-dwa porównać
                  polisy i&nbsp;wybrać idealną, za którą zapłacisz szybkim
                  przelewem.
                </p>
              </div>
            </div>
          </div>
          <div className={classes.fullWidth}>
            <div className={classes.section}>
              <div className={classes.sectionWrapper}>
                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Jak działa kalkulator ubezpieczeń turystycznych?
                  </h2>
                  <p className={classes.paragraph}>
                    Kalkulator ubezpieczeń turystycznych analizuje dane klienta
                    wpisane w&nbsp;formularzu. Na ich podstawie wyszukuje oferty
                    w&nbsp;bazach danych towarzystw ubezpieczeniowych, które
                    współpracują z&nbsp;porównywarką. Jak wygląda proces zakupu
                    polisy krok po kroku?
                  </p>
                  <ol className={classNames(classes.list, classes.listInText)}>
                    <li className={classes.listItem}>
                      <strong>Wypełniasz formularz</strong> – określ kierunek
                      i&nbsp;okres podróży, liczbę osób, które chcesz objąć
                      ochroną ubezpieczeniową, a&nbsp;także podaj datę ich
                      urodzenia i&nbsp;informację o&nbsp;chorobach przewlekłych
                      oraz czy w&nbsp;chwili zakupu polisy wszyscy przebywają
                      w&nbsp;Polsce. Zdradź również, jak zamierzasz spędzać czas
                      w&nbsp;podróży (na wypoczynku i&nbsp;zwiedzaniu,
                      uprawianiu narciarstwa, nurkowania, sportów ekstremalnych
                      lub wyczynowych, pracy fizycznej). Wyślij formularz,
                      klikając "Pokaż oferty".
                    </li>
                    <li className={classes.listItem}>
                      <strong>Porównujesz oferty</strong> – otrzymasz listę
                      pakietów od kilku ubezpieczycieli, w&nbsp;której
                      znajdziesz informacje o&nbsp;rodzajach ochrony
                      i&nbsp;sumach ubezpieczenia, a&nbsp;także cenach
                      wariantów. Więcej informacji otrzymasz w&nbsp;tabeli, gdy
                      klikniesz "Szczegóły oferty". Jeśli znajdziesz pakiet,
                      który spełnia Twoje oczekiwania, kliknij "Kup teraz", aby
                      przejść do kolejnego kroku. Uwaga: jeszcze nie zostaniesz
                      przekierowany do płatności.
                    </li>
                    <li className={classes.listItem}>
                      <strong>Wybierasz dodatkową ochronę</strong> – niektórzy
                      ubezpieczyciele umożliwiają rozszerzenie pakietu
                      ubezpieczeniowego o&nbsp;dodatkowe formy ochrony za
                      opłaceniem dodatkowej składki.
                    </li>
                    <li className={classes.listItem}>
                      <strong>Uzupełniasz dane</strong> – podaj imię
                      i&nbsp;nazwisko, PESEL, adres zameldowania oraz dane
                      kontaktowe potrzebne do obsługi polisy (adres e-mail
                      i&nbsp;numer telefonu). Jeśli ubezpieczasz też osoby,
                      które będą podróżowały z&nbsp;Tobą, wpisz również ich
                      dane.
                    </li>
                    <li className={classes.listItem}>
                      <strong>Płacisz składkę</strong> – należność za polisę
                      wniesiesz szybkim przelewem.
                    </li>
                    <li className={classes.listItem}>
                      <strong>Odbierasz polisę</strong> – polisę i&nbsp;inne
                      niezbędne dokumenty otrzymasz na adres e-mail, który
                      podałeś we wcześniejszych krokach.
                    </li>
                  </ol>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Jakie dane są potrzebne do wystawienia polisy przez
                    porównywarkę Mubi?
                  </h2>
                  <p className={classes.paragraph}>
                    Do wystawienia polisy potrzebne są dane osobowe
                    i&nbsp;teleadresowe. Gdy zdecydujesz się na zakup polisy
                    turystycznej w&nbsp;porównywarce Mubi, zostaniesz poproszony
                    o&nbsp;podanie personaliów, które są niezbędne do
                    wystawienia polisy. Wpisz w&nbsp;odpowiednie rubryki:
                  </p>
                  <ul className={classes.list}>
                    <li>imię i&nbsp;nazwisko,</li>
                    <li>numer PESEL,</li>
                    <li>adres zameldowania,</li>
                    <li>adres e-mail (potrzebny do obsługi polisy),</li>
                    <li>numer telefonu (potrzebny do obsługi polisy).</li>
                  </ul>
                  <p className={classes.paragraph}>
                    Jeśli ubezpieczasz nie tylko siebie, ale też współtowarzyszy
                    podróży, musisz znać również ich dane, łącznie z&nbsp;datą
                    urodzenia i&nbsp;informacjami o&nbsp;chorobach przewlekłych.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Co porównasz w&nbsp;kalkulatorze ubezpieczenia
                    turystycznego?
                  </h2>
                  <p className={classes.paragraph}>
                    W&nbsp;kalkulatorze ubezpieczenia turystycznego poznasz
                    i&nbsp;porównasz zakres ochrony oraz ceny pakietów
                    przygotowanych przez firmy ubezpieczeniowe. Oferty
                    ubezpieczycieli, które otrzymasz w&nbsp;formie tabeli,
                    ukazują, jakie usługi zapewni Ci towarzystwo w&nbsp;ramach
                    polisy po zdarzeniu losowym, a&nbsp;także do jakiej sumy
                    pokryje koszty świadczeń. Przy każdym pakiecie znajdziesz
                    cenę ochrony za cały okres podróży. Ceny porównaj dopiero,
                    gdy wybierzesz oferty, które spełniają Twoje potrzeby
                    i&nbsp;oczekiwania.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Co zobaczysz w&nbsp;wynikach kalkulatora?
                  </h2>
                  <p className={classes.paragraph}>
                    Po wykonaniu kalkulacji otrzymasz dostępne dla Twojej
                    podróży oferty różnych ubezpieczycieli. Możesz je porównać
                    pod względem ceny i&nbsp;zakresu ochrony. Oferty zostaną
                    przedstawione w&nbsp;formie tabeli i&nbsp;domyślnie są
                    uszeregowane od najtańszej do najdroższej polisy. Możesz
                    ustawić inne sortowanie, korzystając z&nbsp;opcji nad
                    tabelą.
                    <br />
                    <br />
                    Każda oferta prezentowana jest według schematu: firma
                    ubezpieczeniowa – rodzaje ochrony wraz z&nbsp;sumami – cena.
                    Obok ceny znajdziesz pomarańczowy przycisk z&nbsp;napisem
                    "Kup teraz&gt;&gt;" umożliwiający zakup wybranej oferty,
                    oraz opcję dodania jej do porównania z&nbsp;innymi
                    pakietami, które przykuły Twoją uwagę. Zakres ochrony
                    przedstawia przede wszystkim najbardziej potrzebne rodzaje,
                    jak koszty leczenia, NNW i&nbsp;OC turystyczne. Niżej
                    zostały wyszczególnione dodatki, które obejmuje dany
                    wariant, np. ubezpieczenie sportowe, ochronę COVID czy
                    zdarzenia pod wpływem alkoholu.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Ile kosztuje ubezpieczenie turystyczne?
                  </h2>
                  <p className={classes.paragraph}>
                    Cena ubezpieczenia turystycznego zależy od zakresu ochrony
                    ubezpieczenia, celu i&nbsp;długości podróży oraz wieku osób
                    ubezpieczonych. Możesz spodziewać się wyższej składki, jeśli
                    wybierzesz pakiet z&nbsp;klauzulą chorób przewlekłych
                    i&nbsp;ubezpieczeniem sportów ekstremalnych, np. jeśli
                    planujesz jazdę na nartach poza wyznaczonymi trasami.
                    Droższe może okazać się też ubezpieczenie na dalsze wyjazdy,
                    np. do Tajlandii czy USA. Z&nbsp;kolei na niższe składki
                    mogą liczyć osoby wyjeżdżające w&nbsp;celach wypoczynkowych
                    i&nbsp;do krajów europejskich. Dokładną cenę poznasz po
                    wykonaniu kalkulacji.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Jak wybrać ubezpieczenie turystyczne?
                  </h2>
                  <p className={classes.paragraph}>
                    Najważniejsza jest suma ubezpieczenia kosztów leczenia,
                    która może wynosić nawet 40&nbsp;000&nbsp;000&nbsp;zł.
                    Ubezpieczenie KL odpowiada za pokrycie kosztów leczenia,
                    zabiegów, operacji, hospitalizacji, badań itp. za granicą.
                    Wraz z&nbsp;nim do ubezpieczenia turystycznego dodawane jest
                    assistance, które zapewnia szereg świadczeń dodatkowych, np.
                    wsparcie w&nbsp;razie utraty dokumentów lub pomoc tłumacza.
                    Równie ważne jest ubezpieczenie kosztów ratownictwa. Akcja
                    ratunkowa za granicą jest w&nbsp;100% płatna
                    i&nbsp;w&nbsp;zależności od stopnia skomplikowania wypadku
                    może kosztować tysiące euro. Sprawdź również sumę
                    ubezpieczenia NNW i&nbsp;OC w&nbsp;życiu prywatnym oraz
                    warunki ubezpieczeń dodatkowych, np. bagażu podręcznego
                    i&nbsp;sprzętu sportowego. Przed zawarciem umowy przeczytaj
                    też wyłączenia odpowiedzialności w&nbsp;ubezpieczeniu
                    turystycznym.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Z&nbsp;jakimi towarzystwami ubezpieczeniowymi współpracuje
                    porównywarka Mubi?
                  </h2>
                  <p className={classes.paragraph}>
                    Pakiety turystyczne przygotują dla Ciebie AXA Partners,
                    Colonnade, ERGO Hestia, ERGO Ubezpieczenia Podróży,
                    Generali, mtu24.pl, Proama, SIGNAL IDUNA, UNIQA, Wiener
                    i&nbsp;You Can Drive. Ta lista to nie jest jednak ostatnie
                    słowo twórców porównywarki. W&nbsp;kalkulatorze sukcesywnie
                    pojawiają się oferty nowych ubezpieczycieli.
                    <br />
                    <br />
                    Po ofertach każdej z&nbsp;firm możesz spodziewać się innej
                    ochrony. Dzięki różnorodnym rodzajom ubezpieczeń
                    w&nbsp;polisach turystycznych oraz zróżnicowanym sumom
                    ubezpieczeń z&nbsp;pewnością znajdziesz takie
                    zabezpieczenie, które będzie odpowiadało Twoim planom
                    wyjazdowym i&nbsp;wymaganiom.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Czy ceny w&nbsp;kalkulatorze Mubi są aktualne?
                  </h2>
                  <p className={classes.paragraph}>
                    Tak. Kalkulator ubezpieczeń turystycznych jest połączony
                    z&nbsp;bazami danych firm ubezpieczeniowych, które
                    udostępniają aktualne oferty z&nbsp;aktualnymi cenami.
                    Ostateczna cena może zmienić się, np. jeżeli wybierzesz
                    dodatkową ochronę.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h2 className={classes.sectionHeader}>
                    Czy kalkulator ubezpieczeń podróżnych jest darmowy
                    i&nbsp;bezpieczny?
                  </h2>
                  <p className={classes.paragraph}>
                    Tak, pod warunkiem, że korzystasz z&nbsp;narzędzia
                    stworzonego przez firmę, która jest licencjonowanym
                    pośrednikiem ubezpieczeniowym, a&nbsp;więc została wpisana
                    do Rejestru Agentów Ubezpieczeniowych, nad którym czuwa
                    Komisja Nadzoru Finansowego. Porównywarka mubi.pl spełnia
                    wszystkie te warunki.
                    <br />
                    <br />
                    Kalkulator ubezpieczeń podróżnych Mubi jest ponadto darmowy
                    i&nbsp;nie zawiera żadnych ukrytych opłat. Płacisz jedynie
                    składkę ubezpieczeniową za wybrany przez siebie pakiet
                    ochrony na wyjazd. Jeśli porównywarka ubezpieczeń wymaga od
                    Ciebie np. wysłania płatnego SMS-a przed udzieleniem dostępu
                    do ofert, powinno to wzbudzić Twoją czujność. Może to być
                    próba wyłudzenia pieniędzy lub danych.
                  </p>
                </div>
              </div>
            </div>

            <div className={classes.section}>
              <div className={classes.sectionWrapper}>
                <HeaderWithIcon>
                  FAQ – najczęściej zadawane pytania o&nbsp;kalkulator
                  ubezpieczeń turystycznych
                </HeaderWithIcon>

                <div className={classes.descriptionBox}>
                  <h3 className={classes.sectionHeader}>
                    Czy muszę kupić polisę po kalkulacji?
                  </h3>
                  <p className={classes.paragraph}>
                    Nie, możesz wyliczyć składkę w&nbsp;kalkulatorze ubezpieczeń
                    turystycznych orientacyjnie lub z&nbsp;wyprzedzeniem
                    i&nbsp;odłożyć zakup polisy na jakiś czas. Żeby łatwiej
                    wrócić do ofert, które otrzymałeś, możesz podać adres
                    e-mail. Miejsce na wpisanie go znajduje się na końcu
                    formularza.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h3 className={classes.sectionHeader}>
                    Czy mogę ubezpieczyć kilka osób?
                  </h3>
                  <p className={classes.paragraph}>
                    Tak, w&nbsp;kalkulatorze ubezpieczeń Mubi możesz ubezpieczyć
                    nawet 10 osób w&nbsp;ramach jednej polisy. Wówczas wybierz
                    odpowiednią liczbę podróżnych w&nbsp;formularzu i&nbsp;wskaż
                    datę urodzenia każdego z&nbsp;nich. Jeśli ktoś z&nbsp;Was
                    choruje przewlekle, poinformuj o&nbsp;tym ubezpieczyciela,
                    zaznaczając okienko przy osobach, których to dotyczy.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h3 className={classes.sectionHeader}>
                    Czy mogę kupić ubezpieczenie turystyczne w&nbsp;dniu
                    wyjazdu?
                  </h3>
                  <p className={classes.paragraph}>
                    Tak, możesz zawrzeć polisę w&nbsp;dniu wyjazdu. To ogromna
                    zaleta kalkulatora ubezpieczeń, że umożliwia zakup polisy
                    w&nbsp;dowolnym momencie. Pamiętaj jednak, że jeśli
                    znajdujesz się już w&nbsp;podróży, ubezpieczyciel może
                    zastosować tzw. karencję, czyli odroczyć start ochrony
                    ubezpieczeniowej o&nbsp;kilka godzin lub dni.
                  </p>
                </div>

                <div className={classes.descriptionBox}>
                  <h3 className={classes.sectionHeader}>
                    Czy mogę kupić ubezpieczenie, jeśli jestem już za granicą?
                  </h3>
                  <p className={classes.paragraph}>
                    Tak, możesz kupić ubezpieczenie, nawet jeśli jesteś już poza
                    krajem zamieszkania. W&nbsp;takim przypadku zaznacz tę
                    informację w&nbsp;formularzu kalkulatora. Uwaga: jeśli
                    ubezpieczasz się, już przebywając za granicą, Twoja polisa
                    prawdopodobnie nie zacznie działać od razu. W&nbsp;takich
                    sytuacjach ubezpieczyciele opóźniają start ochrony
                    o&nbsp;kilka godzin lub dni.
                  </p>
                </div>

                <NewButton
                  title={ButtonLabelEnum.Up}
                  variant="contained"
                  color="primary"
                  size="large"
                  endIcon={<ArrowUp />}
                  onClick={() => scrollSmoothly(0)}
                  className={classes.up}
                />
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default TravelQuestionsAndAnswers;
